/* eslint-disable eqeqeq */
import {
  Card,
  FormControlLabel,
  LinearProgress,
  Radio,
} from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import {
  Alert,
  Badge,
  Button,
  ButtonToolbar,
  Form,
  Modal,
  Table,
} from "react-bootstrap";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { Notice, YearSelect } from "../../../_metronic/_partials/controls";
import AppConfig from "../../config/AppConfig";

class DampakTridharma extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.inputChange = this.inputChange.bind(this);
    this.showDetails = this.showDetails.bind(this);
    this.showHistorical = this.showHistorical.bind(this);
  }
  state = {
    showDialogAdd: false,
    showDetails: false,
    modalEdit: false,
    loading: false,
    loading2: true,
    loading_details: true,
    get_ref: [],
    get_list: [],
    get_details: [],
    showHistorical: false,
    data_historical: [],
    loadingHistorical: false,
    // FORM
    id_DampakTridharma: [],
    id_pengaturan: [],
    nama: [],
    rtm: [],
    bukti_rtm: [],
    rtl: [],
    bukti_rtl: [],
    tautan: "",
    nama_bidang: "",
    deskripsi: "",
    check1: false,
    check2: true,
    check3: false,
    check4: true,
    id_question: "",
    question: "",
    answer: "",
  };

  handleAdd(id,) {
    this.setState({
      showDialogAdd: true,
      id_question: id,
      question: this.state.get_list.find((item) => item.id === id)?.question || "",
      answer: this.state.get_list.find((item) => item.id === id)?.answer || "",
    });
  }

  handleClose() {
    this.setState({
      showDialogAdd: false,
      showDetails: false,
      modalEdit: false,
      loading: false,
      nama: [],
      rtm: [],
      rtl: [],
      bukti_rtm: [],
      bukti_rtl: [],
      tautan: "",
      nama_bidang: "",
      deskripsi: "",
      check1: false,
      check2: true,
      check3: false,
      check4: true,
      showHistorical: false,
      data_historical: [],
      loadingHistorical: false,
    });
  }
  onInputChangePengaturan = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };

  inputChange = (e, type) => {
    if (e === 0) {
      this.setState({
        check1: true,
        check2: false,
      });
    } else if (e === 1) {
      this.setState({
        check1: false,
        check2: true,
      });
    }
    if (e === 2) {
      this.setState({
        check3: true,
        check4: false,
      });
    } else if (e === 3) {
      this.setState({
        check3: false,
        check4: true,
      });
    }
  };

  showDetails = (id) => {
    this.setState({ showDetails: true, loading_details: true });
    axios
      .get(AppConfig.DetailsDampakTridharma + id)
      .then((res) => {
        this.setState(
          {
            get_details: res.data.result.detail,
            loading_details: false,
          },
          () => {
            console.log(this.state.get_details);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  showHistorical = (jenis) => {
    this.setState({ showHistorical: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    let id_institusi = localStorage.getItem("id_sp_temp");
    if (id_institusi === undefined) {
      id_institusi = sessiondata.i_idunit;
    }
    axios
      .get(AppConfig.GetHistorical + id_institusi + "/" + jenis + session)
      .then((res) => {
        this.setState({
          data_historical: res.data.result.data,
          loadingHistorical: true,
        });
      })
      .catch((err) => {
        this.setState({
          display_edit: false,
          showDialogFormSave: false,
        });
      });
  };
  handleSave = (e) => {
    e.preventDefault();
    var formData = new FormData();
    this.setState({ loading: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    formData.append("data[id_sp]", sessiondata.i_idunit);
    formData.append("data[id_question]", this.state.id_question);
    formData.append("data[answer]", this.state.answer);
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    formData.append("data[tahun_siklus]", tahun_siklus);
    axios
      .post(AppConfig.DampakTridharmaSave + session, formData)
      .then((res) => {
        this.setState(
          {
            loading: false,
          },
        );
        swal({
          title: "Berhasil!",
          text: "Jawaban berhasil disimpan!",
          icon: "success",
          button: "OK!",
        });
        console.log(res);
        this.componentDidMount();
        this.handleClose();
      })
      .catch((err) => {
        swal({
          title: "Gagal!",
          text: "Jawaban tidak berhasil disimpan!",
          icon: "error",
          button: "OK!",
        });
        console.log(err);
      });
  };
  componentDidMount() {
    let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    if (this.props.idSp !== undefined) {
      id_sp = this.props.idSp;
    }
    if (id_sp) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    axios
      .get(AppConfig.FormRefDampakTridharma)
      .then((res) => {
        this.setState({
          get_ref: res.data.result.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(AppConfig.DampakTridharmaListSiklus + id_sp + "/" + tahun_siklus + session)
      .then((res) => {
        this.setState({
          loading2: false,
          get_list: res.data.result.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handhandleShowHistorical = (id) => {
    this.setState({ showHistorical: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    let id_institusi = localStorage.getItem("id_sp_temp");
    if (id_institusi === undefined) {
      id_institusi = sessiondata.i_idunit;
    }
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    axios
      .get(
        AppConfig.DampakTridharmaHistorySiklus + id_institusi + "/" + id + "/" + tahun_siklus + session
      )
      .then((res) => {
        console.log(res);
        this.setState({
          data_historical: res.data.result.data,
          loadingHistorical: true,
        });
      })
      .catch((err) => {
        this.setState({
          loadingHistorical: false,
        });
      });
  };

  handleDelete = (id) => {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "DampakTridharma akan dihapus",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loading: true });
        axios
          .delete(AppConfig.DampakTridharmaDelete + id + session)
          .then((res) => {
            swal({
              title: "Berhasil!",
              text: "Dampak Tridharma berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.componentDidMount();
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Dampak Tridharma gagal dihapus!",
              icon: "error",
              button: "OK!",
            });
          });
      }
    });
  };
  render() {
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    let {
      loading,
      get_ref,
      get_list,
      check1,
      check2,
      check3,
      check4,
      nama,
      rtm,
      rtl,
      bukti_rtm,
      bukti_rtl,
      data_historical,
      tautan,
      nama_bidang,
      deskripsi,
    } = this.state;
    let i = 0;
    let result = [];
    if (get_ref !== undefined) {
      for (var key in get_ref) {
        result[i] = {
          result: get_ref[key],
        };
        i++;
      }
    }
    let ii = 0;
    let list_result = [];
    if (get_list !== undefined) {
      for (var key in get_list) {
        list_result[ii] = {
          result: get_list[key],
        };
        ii++;
      }
    }

    let display_historical = [];
    if (this.state.loadingHistorical === true) {
      data_historical.map((list, i) => {
        display_historical.push(
          <>
            <tr>
              <td style={{ textAlign: "center" }}> {i + 1}</td>
              <td style={{ textAlign: "left" }}>
                <div
                    dangerouslySetInnerHTML={{
                      __html: list.question,
                    }}
                  />
              </td>
              <td style={{ textAlign: "left" }}>
                {list.answer !== "null" ? list.answer : "-"}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.status_verified === 1 ? (
                  <Badge
                    pill
                    variant="success"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#37bf30" }}>✔</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Terverifikasi
                  </Badge>
                ) : (
                  <Badge
                    pill
                    variant="secondary"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#858585" }}>•</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Belum Terverifikasi
                  </Badge>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.date_verified === "null" ? (
                  "-"
                ) : (
                  <Moment
                    format="DD/MM/YYYY"
                    date={
                      list.date_verified
                    }
                  />
                )}
              </td>
            </tr>
          </>
        );
      });
    } else {
      display_historical = (
        <>
          <tr>
            <td colSpan="5">
              <LinearProgress color="secondary" variant="query" />
            </td>
          </tr>
        </>
      );
    }
    return (
      console.log(userdata),
      (
        <>
          <Notice
            svg="/media/svg/icons/General/Bookmark.svg"
            style={{ marginBottom: "0px", boxShadow: "none" }}
          >
            <div className="d-flex align-items-center justify-content-between w-100">
              <div>
                <strong style={{ fontSize: "18px" }}>Dampak Tridharma</strong>
                <p className="mb-0">Dampak Tridharma dalam DUDIKA atau Masyarakat</p>
              </div>
              <div>
                <YearSelect />
              </div>
            </div>
          </Notice>
          <br />
          <Card style={{ padding: "2%" }}>
            <Table responsive style={{ overflow: "auto" }}>
              <thead
                className="text-white"
                style={{ backgroundColor: "#3047ad" }}
              >
                <tr>
                  <th
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                      textAlign: "center",
                      width: "5%",
                    }}
                  >
                    No
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                      textAlign: "left",
                      width: "35%",
                    }}
                  >
                    Pertanyaan
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                      textAlign: "left",
                      width: "35%",
                    }}
                  >
                    Jawaban
                  </th>
                  <th
                    className="text-center"
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                      textAlign: "center",
                      width: "10%",
                    }}
                  >
                    Tahun
                  </th>
                  <th
                    className="text-center"
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                      textAlign: "center",
                      width: "15%",
                    }}
                  >
                    Status Verifikasi
                  </th>
                  <th
                    className="text-center"
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                      textAlign: "center",
                      width: "15%",
                    }}
                  >
                    Tanggal Terverifikasi
                  </th>
                  <th
                    className="text-center"
                    style={{
                      fontSize: "12px",
                      textTransform: "uppercase",
                      verticalAlign: "middle",
                      textAlign: "center",
                      width: "10%",
                    }}
                  >
                    Aksi
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.state.loading2 === true ? (
                  <tr>
                    <td colSpan="7">
                      <LinearProgress color="secondary" variant="query" />
                    </td>
                  </tr>
                ) : list_result.length > 0 ? (
                  list_result.map((list, i) => (
                    <tr>
                      <td style={{ textAlign: "center", verticalAlign: "top" }}>
                        {i + 1}
                      </td>
                      <td style={{ textAlign: "", verticalAlign: "top" }}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: list.result.question,
                          }}
                        />
                      </td>
                      {
                        (list.result.answer_id !== "null")
                          ?
                          <>
                            <td style={{ textAlign: "", verticalAlign: "top" }}>
                              {list.result.answer !== "" ? list.result.answer : '-'}
                            </td>
                            <td style={{ textAlign: "center", verticalAlign: "top" }}>
                              -
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                verticalAlign: "top",
                              }}
                            >
                              {list.result.status_verified === 1 ? (
                                <Badge
                                  pill
                                  variant="success"
                                  style={{
                                    backgroundColor: "#BEF2FF",
                                    color: "#334443",
                                    fontSize: "12px",
                                  }}
                                >
                                  <Badge variant="light">
                                    {" "}
                                    <span style={{ color: "#37bf30" }}>✔</span>
                                  </Badge>
                                  &nbsp;&nbsp;&nbsp; Terverifikasi
                                </Badge>
                              ) : (
                                <Badge
                                  pill
                                  variant="secondary"
                                  style={{
                                    backgroundColor: "#BEF2FF",
                                    color: "#334443",
                                    fontSize: "12px",
                                  }}
                                >
                                  Belum Terverifikasi
                                </Badge>
                              )}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                fontSize: "12px",
                                verticalAlign: "top",
                              }}
                            >
                              {list.result.date_verified === "null" ? (
                                "-"
                              ) : (
                                <Moment
                                  format="DD/MM/YYYY"
                                  date={list.result.date_verified}
                                />
                              )}
                            </td>
                          </>
                          :
                          <td style={{ textAlign: "center", verticalAlign: "top" }} colSpan={4}>
                            <i style={{ fontSize: "12px" }}>Belum diisi</i>
                          </td>
                      }

                      <td className="text-center">
                        {(userdata.i_idrole === 3 ||
                          userdata.i_idrole === 10 ||
                          userdata.i_idrole === 2013 ||
                          userdata.i_idrole === 2014) && list.result.answer_id !== "null" ? (
                          <Link
                            to={
                              "/dampak-tridharma-detail/" +
                              list.result.answer_id
                            }
                          >
                            <Button
                              className="btn btn-icon btn-primary btn-sm"
                              style={{
                                minWidth: "50px",
                                marginLeft: "5px",
                                borderRadius: "12px",
                              }}
                            >
                              <i
                                class="flaticon-eye"
                                style={{ color: "#ffffff", fontSize: "14px" }}
                              ></i>
                            </Button>
                          </Link>
                        ) : (
                          ""
                        )}
                        {userdata.i_idrole === 3 && list.result.answer_id !== "null" ? (
                          <>
                          {
                            list.result.status_verified === 0? (<Button
                              onClick={() =>
                                this.handleAdd(list.result.id)
                              }
                              className="btn btn-icon btn-warning btn-sm"
                              style={{
                                minWidth: "50px",
                                marginLeft: "5px",
                                margintight: "5px",
                                borderRadius: "12px",
                              }}
                            >
                              <i
                                class="flaticon-edit"
                                style={{ fontSize: "14px" }}
                              ></i>
                            </Button>) : ("")
                          }
                          </>
                        ) : (
                          ""
                        )}
                        {userdata.i_idrole === 3 && list.result.answer_id !== "null" && list.result.status_verified === 0 && list.result.jumlah_comment === 0 ? (
                          <>
                            <Button
                              onClick={() =>
                                this.handleDelete(list.result.answer_id)
                              }
                              className="btn btn-icon btn-danger btn-sm"
                              style={{
                                minWidth: "50px",
                                marginLeft: "5px",
                                borderRadius: "12px",
                              }}
                            >
                              <i
                                class="flaticon-delete"
                                style={{ fontSize: "14px" }}
                              ></i>
                            </Button>
                          </>
                        ) : (
                          ""
                        )}

                        {
                          (list.result.answer_id !== "null") ?
                            <Button
                              onClick={() =>
                                this.handhandleShowHistorical(
                                  list.result.id
                                )
                              }
                              className="btn btn-icon btn-success btn-sm"
                              style={{
                                minWidth: "50px",
                                borderRadius: "12px",
                                marginLeft: "5px",
                              }}
                            >
                              <i
                                class="flaticon2-time"
                                style={{ color: "#ffffff", fontSize: "14px" }}
                              ></i>
                            </Button> : ""
                        }
                        {userdata.i_idrole === 3 && list.result.answer_id === "null" ? (
                          <>
                            <Button
                              onClick={() =>
                                this.handleAdd(list.result.id)
                              }
                              className="btn btn-icon btn-primary btn-sm"
                              style={{
                                minWidth: "50px",
                                marginLeft: "5px",
                                margintight: "5px",
                                borderRadius: "12px",
                              }}
                            >
                              <i
                                class="flaticon-plus"
                                style={{ fontSize: "14px" }}
                              ></i>
                            </Button>
                          </>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      <em>Data does not exist</em>
                    </td>
                  </>
                )}
              </tbody>
            </Table>
          </Card>

          {/* MODAL ADD */}
          <Modal
            size="lg"
            show={this.state.showDialogAdd}
            onHide={this.handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>Update Dampak Tridharma</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Label>
                Pertanyaan :{" "}
              </Form.Label>
              <Form.Text style={{ fontSize: "14px" }}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.state.question,
                  }}
                />
              </Form.Text>
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Jawaban :
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                as="textarea"
                placeholder="Isikan jawaban anda disini"
                value={this.state.answer !== "null" ? this.state.answer : "-"}
                onChange={(e) => this.onInputChangePengaturan(e, "answer")}
              />
            </Modal.Body>
            <Modal.Footer>
              <div style={{ textAlign: "right" }}>
                <Button
                  onClick={this.handleSave}
                  disabled={loading}
                  style={{
                    marginRight: "1vw",
                    backgroundColor: "#2061e3",
                    color: "white",
                  }}
                  variant="primary"
                >
                  SIMPAN
                  {loading && <i className="ml-3 spinner spinner-white"></i>}
                  &nbsp;&nbsp;
                </Button>
              </div>
              <Button variant="secondary" onClick={this.handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          {/* SHOW DETAILS */}
          <Modal
            size="lg"
            show={this.state.showDetails}
            onHide={this.handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>Details DampakTridharma</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.loading_details === true ? (
                <>
                  <div className="row">
                    <div className="col-md-12">
                      <LinearProgress color="secondary" variant="query" />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="row row-paddingless">
                    <div className="col-md-4">
                      <strong>Bidang Pengaturan standar :</strong>
                    </div>
                    <div className="col-md-8">
                      {this.state.get_details.nama_jenis}
                    </div>
                  </div>
                  <hr />
                  <div className="row row-paddingless">
                    <div className="col-md-4">
                      <strong>Tautan RTM (Rapat Tinjau Manajemen) :</strong>
                    </div>
                    <div className="col-md-7">{this.state.get_details.rtm}</div>
                    <div className="col-md-1">
                      <Button
                        href={this.state.get_details.rtm}
                        target="_blank"
                        className="btn btn-icon btn-light btn-sm"
                        style={{
                          minWidth: "50px",
                          borderRadius: "12px",
                          background: "#A9C6DE",
                        }}
                      >
                        <i
                          class="flaticon-attachment"
                          style={{ color: "#3F4254", fontSize: "14px" }}
                        ></i>
                      </Button>
                    </div>
                  </div>
                  <hr />
                  <div className="row row-paddingless">
                    <div className="col-md-4">
                      <strong>Bukti Pelaksanaan RTM :</strong>
                    </div>
                    <div className="col-md-7">
                      {this.state.get_details.bukti_rtm !== "null"
                        ? this.state.get_details.bukti_rtm
                        : "-"}
                    </div>
                    <div className="col-md-1">
                      {this.state.get_details.bukti_rtm !== "null" ? (
                        <>
                          <Button
                            href={this.state.get_details.bukti_rtm}
                            target="_blank"
                            className="btn btn-icon btn-light btn-sm"
                            style={{
                              minWidth: "50px",
                              borderRadius: "12px",
                              background: "#A9C6DE",
                            }}
                          >
                            <i
                              class="flaticon-attachment"
                              style={{ color: "#3F4254", fontSize: "14px" }}
                            ></i>
                          </Button>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <hr />
                  <div className="row row-paddingless">
                    <div className="col-md-4">
                      <strong>Tautan RTL (Rencana Tindak Lanjut) :</strong>
                    </div>
                    <div className="col-md-7">{this.state.get_details.rtl}</div>
                    <div className="col-md-1">
                      <Button
                        href={this.state.get_details.rtl}
                        target="_blank"
                        className="btn btn-icon btn-light btn-sm"
                        style={{
                          minWidth: "50px",
                          borderRadius: "12px",
                          background: "#A9C6DE",
                        }}
                      >
                        <i
                          class="flaticon-attachment"
                          style={{ color: "#3F4254", fontSize: "14px" }}
                        ></i>
                      </Button>
                    </div>
                  </div>
                  <hr />
                  <div className="row row-paddingless">
                    <div className="col-md-4">
                      <strong>Bukti Pelaksanaan RTL :</strong>
                    </div>
                    <div className="col-md-7">
                      {this.state.get_details.bukti_rtl !== "null"
                        ? this.state.get_details.bukti_rtl
                        : "-"}
                    </div>
                    <div className="col-md-1">
                      {this.state.get_details.bukti_rtl !== "null" ? (
                        <>
                          <Button
                            href={this.state.get_details.bukti_rtl}
                            target="_blank"
                            className="btn btn-icon btn-light btn-sm"
                            style={{
                              minWidth: "50px",
                              borderRadius: "12px",
                              background: "#A9C6DE",
                            }}
                          >
                            <i
                              class="flaticon-attachment"
                              style={{ color: "#3F4254", fontSize: "14px" }}
                            ></i>
                          </Button>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            size="lg"
            show={this.state.showHistorical}
            onHide={this.handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>Riwayat Dampak Tridharma</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Table responsive style={{ overflow: "auto" }}>
                <thead
                  className="text-white"
                  style={{ backgroundColor: "#3047ad" }}
                >
                  <th style={{ textAlign: "center" }}>No</th>
                  <th style={{ textAlign: "left" }}>Pertanyaan</th>
                  <th style={{ textAlign: "left" }}>Jawaban</th>
                  <th style={{ textAlign: "center" }}>Status Verifikasi</th>
                  <th style={{ textAlign: "center" }}>Tanggal Terverifikasi</th>
                </thead>
                <tbody>{display_historical}</tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )
    );
  }
}
export default DampakTridharma;
